import { render, staticRenderFns } from "./DoctorDocumentsModal.vue?vue&type=template&id=7ee8de9b&"
import script from "./DoctorDocumentsModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorDocumentsModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee8de9b')) {
      api.createRecord('7ee8de9b', component.options)
    } else {
      api.reload('7ee8de9b', component.options)
    }
    module.hot.accept("./DoctorDocumentsModal.vue?vue&type=template&id=7ee8de9b&", function () {
      api.rerender('7ee8de9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DoctorDocumentsModal/DoctorDocumentsModal.vue"
export default component.exports